import { Component, Input, OnInit } from '@angular/core';
import { MatTableDataSource } from "@angular/material/table";
import { statsColums } from "../shared/stats/stats-columns-data";

@Component({
  selector: 'app-statistic-rotation',
  templateUrl: './statistic-rotation.component.html',
  styleUrls: ['./statistic-rotation.component.scss']
})
export class StatisticRotationComponent implements OnInit {
  @Input()
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  displayedColumns = ['codeArticle', 'libelleArticle', 'qt_sem', 'tx_rot', 'qt_sem_1_traitees', 'qt_sem_2_traitees', 'qt_sem_3_traitees', 'qt_sem_4_traitees', 'qt_sem_5_traitees', 'qt_mab', 'qt_theo', 'stock', 'qt_diff'];
  displayedColumnsAnett = ['codeArticle', 'libelleArticle', 'qt_sem', 'tx_rot', 'qt_sem_1_traitees', 'qt_sem_2_traitees', 'qt_sem_3_traitees', 'qt_sem_4_traitees', 'qt_sem_5_traitees', 'cal', 'qt_mab', 'qt_theo', 'stock', 'qt_diff'];
  columns: any = statsColums;
  allqt = [];

  constructor() { }

  ngOnInit() {
    this.columns = statsColums;
  }

}
